var _path, _rect, _rect2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaintrustLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 58,
    viewBox: "0 0 81 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.89217 25.8017C-0.275823 26.9768 -0.275825 28.8821 0.892168 30.0572L17.5389 46.8059C18.7069 47.981 20.6006 47.981 21.7686 46.8059L38.4154 30.0572C39.5834 28.8821 39.5834 26.9768 38.4154 25.8017L21.7686 9.053C20.6006 7.87786 18.7069 7.87786 17.5389 9.053L0.89217 25.8017ZM42.6535 25.8021C41.4852 26.977 41.4852 28.8819 42.6535 30.0568L58.2596 45.7521C59.4278 46.927 61.3219 46.927 62.4901 45.7521L79.1402 29.0068C80.3085 27.8319 80.3085 25.927 79.1403 24.7521L63.5341 9.05676C62.3659 7.88186 60.4718 7.88186 59.3036 9.05676L42.6535 25.8021Z",
    fill: "url(#paint0_radial_409_22)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.4777,
    height: 39.4777,
    rx: 5,
    transform: "matrix(0.704946 -0.709261 0.704946 0.709261 12.6222 32)",
    fill: "#024CF8",
    fillOpacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39.4777,
    height: 39.4777,
    rx: 5,
    transform: "matrix(0.704946 -0.709261 0.704946 0.709261 12.6222 28)",
    fill: "url(#paint1_linear_409_22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2079 35.8481C51.1371 35.4917 50.8537 35.1709 50.4995 35.1353C50.1453 35.064 49.8619 35.2066 49.6848 35.3848C47.3116 37.6656 44.9029 38.9129 41.467 38.9129C35.4808 38.9129 30.8406 33.9236 30.8406 27.5087V27.4374C30.8406 26.689 30.9115 25.9406 31.0177 25.2635C31.124 24.6577 30.6635 24.1231 30.0613 24.1231C29.6009 24.1231 29.2112 24.4438 29.1404 24.9071C28.9633 25.7268 28.8924 26.6178 28.8924 27.5087V27.58C28.8924 34.8502 34.2056 40.5879 41.3962 40.5879C45.6113 40.5879 48.4096 39.0555 50.9599 36.6677C51.1016 36.4895 51.2787 36.2044 51.2079 35.8481ZM32.1866 20.9513C32.47 20.9513 32.7534 20.8087 32.8951 20.5593C34.8078 17.8508 37.854 16.1045 41.4316 16.1045C44.9737 16.1045 47.3824 17.4588 49.4723 19.3832C49.6139 19.5258 49.8619 19.6327 50.1098 19.6327C50.6057 19.6327 51.1016 19.205 51.1016 18.7061C51.1016 18.3854 50.9245 18.1359 50.7474 17.9577C48.2679 15.855 45.6467 14.3939 41.467 14.3939C37.2519 14.3939 33.6743 16.3896 31.4428 19.4901C30.9823 20.096 31.4428 20.9513 32.1866 20.9513Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_409_22",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.2723 11.1107) rotate(26.1402) scale(86.4558 59.2433)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.336621,
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996312,
    stopColor: "#9FD8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_409_22",
    x1: 36.1389,
    y1: 1.5463,
    x2: 1.76687,
    y2: 46.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#9FD8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaintrustLogo);
export default __webpack_public_path__ + "static/media/chaintrust-logo.70a9a915.svg";
export { ForwardRef as ReactComponent };